import React from "react";

/*
 * This component displays a card for a spot in the best spots list
 */

const SpotCard = (props) => {
  const fishTypes = props.data.fishTypes[props.language].map((f, i) => (
    <div key={i}>{f}</div>
  ));
  return (
    <div
      className="spotCard card mb-2 spotListItem"
      onClick={() => {
        props.openSpot(props.data);
      }}
      style={props.selected ? selectedStyle : {}}
    >
      <div className="dataBar">
        <span className="name info">{props.data.name}</span>
        <span className="distance info">
          {props.data.distance && `${props.data.distance} km`}
        </span>
        <span className="coast info">
          {props.data.coastType[props.language]}
        </span>
        <span className="types info">{fishTypes}</span>
      </div>
    </div>
  );
};

const selectedStyle = {
  fontWeight: "bold",
};

export default SpotCard;
